import React from "react";
import { getFromStorage } from "../../utils/Helper";
import { StorageConstant } from "../../constants/Constants";
import LandingMarketingNav from "../home/LandingMarketingNav";
import Footer from "../home/Footer";
import ContactSupportForm from "./ContactSupportForm";
import "../home/landing.scss";
import "../cms/Cms.scss";
import "./ContactSupportPage.scss";

function ContactSupportPage() {
  const hasAccessToken = Boolean(getFromStorage({ key: StorageConstant?.ACCESS_TOKEN }));

  return (
    <div className={`landing-page cms-page contact-support-standalone${hasAccessToken ? " landing-page--app-header" : ""}`}>
      {!hasAccessToken ? <LandingMarketingNav /> : null}

      <main className="contact-support-standalone__main">
        <div className="contact-support-page">
          <ContactSupportForm idPrefix="contact-support-page" variant="page" />
        </div>
      </main>

      <Footer />
    </div>
  );
}

export default ContactSupportPage;
